import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
// import 'rxjs/Rx';


import { FonziComponent } from './fonzi.component';

// Route module
import { FonziRoutingModule } from './fonzi.routing.module';

// Components
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { HomePageComponent } from './home-page/home-page.component';
import { NotFoundComponent } from './not-found/not-found.component';


import { SellButtonsComponent } from './sell-buttons/sell-buttons.component';
import { BuyButtonsComponent } from './buy-buttons/buy-buttons.component';
import { BrandListComponent } from './brand-list/brand-list.component';
import { AllBrandsComponent } from './all-brands/all-brands.component';
import { VariantListComponent } from './variant-list/variant-list.component';
import { VariantComponent } from './variant/variant.component';
import { VariantDetailsComponent } from './variant-details/variant-details.component';
import { PhoneOrVariantComponent } from './phone-or-variant/phone-or-variant.component';
import { PhoneListComponent } from './phone-list/phone-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    FonziRoutingModule
  ],
  declarations: [
    FonziComponent,
    HeaderComponent,
    FooterComponent,
    SearchBarComponent,
    HomePageComponent,
    NotFoundComponent,
    SellButtonsComponent,
    BuyButtonsComponent,
    BrandListComponent,
    AllBrandsComponent,
    VariantListComponent,
    VariantComponent,
    VariantDetailsComponent,
    PhoneOrVariantComponent,
    PhoneListComponent
  ],
  exports: [
    SearchBarComponent
  ],
  providers: []
})
export class FonziModule { }



// WEBPACK FOOTER //
// ./src/app/fonzi-module/fonzi.module.ts